import { trackEvent } from './analytics'

// --- Authentication Events ---

export const trackSignUp = (method = 'email') => {
  trackEvent('sign_up', { method })
}

export const trackSignIn = (method = 'email') => {
  trackEvent('login', { method })
}

export const trackSignOut = () => {
  trackEvent('sign_out')
}

export const trackPasswordResetRequest = () => {
  trackEvent('password_reset_request')
}

export const trackPasswordResetComplete = () => {
  trackEvent('password_reset_complete')
}

export const trackResendVerification = () => {
  trackEvent('resend_verification')
}

export const trackAuthFormSwitch = (formType) => {
  trackEvent('auth_form_switch', { form_type: formType })
}

// --- API Key Events ---

export const trackApiKeyCreated = () => {
  trackEvent('api_key_created')
}

export const trackApiKeyCopied = () => {
  trackEvent('api_key_copied')
}

export const trackApiKeyRevoked = () => {
  trackEvent('api_key_revoked')
}

// --- Pricing / Payment Events ---

export const trackPlanSelected = (planName, billingPeriod) => {
  trackEvent('plan_selected', {
    plan_name: planName,
    billing_period: billingPeriod,
  })
}

export const trackBillingPeriodToggle = (period) => {
  trackEvent('billing_period_toggle', { period })
}

export const trackManageSubscription = () => {
  trackEvent('manage_subscription')
}

export const trackManagePayment = () => {
  trackEvent('manage_payment')
}

export const trackInvoiceDownload = () => {
  trackEvent('invoice_download')
}

// --- CTA / Navigation Events ---

export const trackCTAClick = (ctaName, location) => {
  trackEvent('cta_click', {
    cta_name: ctaName,
    location,
  })
}

export const trackExternalLinkClick = (linkName, url) => {
  trackEvent('external_link_click', {
    link_name: linkName,
    link_url: url,
  })
}

// --- Dashboard Events ---

export const trackDashboardTabSwitch = (tabName) => {
  trackEvent('dashboard_tab_switch', { tab_name: tabName })
}

export const trackCodeExampleCopied = (language) => {
  trackEvent('code_example_copied', { language })
}

export const trackCodeLanguageSwitch = (language) => {
  trackEvent('code_language_switch', { language })
}

// --- Account Events ---

export const trackChangePassword = () => {
  trackEvent('change_password')
}

export const trackDeleteAccount = () => {
  trackEvent('delete_account')
}

// --- Cookie Consent Events ---

export const trackCookieConsentAccepted = () => {
  trackEvent('cookie_consent_accepted')
}

export const trackCookieConsentRejected = () => {
  trackEvent('cookie_consent_rejected')
}

export const trackCookieConsentCustomized = (analyticsEnabled) => {
  trackEvent('cookie_consent_customized', { analytics_enabled: analyticsEnabled })
}
